import React, { useState, useEffect } from "react";
import { createContext, useContext } from "react";



export const CommonContext = createContext();

const NotificationContextProvider = ({ children }) => {
  const [loader, setLoader] = useState(false);
  const [amenitiesData, setAmenitiesData] = useState([]);
  const [providerData, setProviderData] = useState([]);

  const [data, setData] = useState({
    propertyTypeData: {
      content: [
        {
          name: "",
          nameAr: "",
          value: "",
        },
      ],
    },
    roomClassData: {
      content: [
        {
          name: "",
          nameAr: "",
          value: "",
        },
      ],
    },
    roomTypeData: {
      content: [
        {
          name: "",
          nameAr: "",
          value: "",
        },
      ],
    },
    roomViewData: {
      content: [
        {
          name: "",
          nameAr: "",
          value: "",
        },
      ],
    },
    roomBeddingData: {
      content: [
        {
          name: "",
          nameAr: "",
          value: "",
        },
      ],
    },
  });

  const [notifications, setNotifications] = useState(false);
  const [notificationCount, setNotificationCount] = useState();

  const getAllNotifications = () => {
    getNotifications()
      .then((res) => {
        setNotifications(res?.data?.getData);
        setNotificationCount(res?.data?.totalUnRead);
      })
      .catch((err) => {
        console.log(err, "err of user data ");
        setNotificationCount([]);
      });
  };

  const fetchAmenities = (search = "") => {
    setLoader(true)
    getAmenities(search)
      .then((res) => {
        setAmenitiesData(res?.data);
        setLoader(false)
      })
      .catch((err) => {
        console.log(err, "error getting amenities  data");
        setLoader(false)
      });
  };
  const fetchProviders = (search = "") => {
    setLoader(true)
    getProviderData(search)
      .then((res) => {
        setProviderData(res?.data);
        setLoader(false)
      })
      .catch((err) => {
        console.log(err, "error getting amenities  data");
        setLoader(false)
      });
  };

  const fetchData = async () => {
    try {
      setLoader(true);
      const fetchedData = await getOptions();

      if (fetchedData.status === 200) {
        const types = [
          { key: "propertyTypeData", type: "property_type_options" },
          { key: "roomClassData", type: "room_class_options" },
          { key: "roomTypeData", type: "room_type_options" },
          { key: "roomViewData", type: "view_type_options" },
          { key: "roomBeddingData", type: "room_bedding_options" },
        ];

        const updatedData = types.reduce((acc, { key, type }) => {
          const found = fetchedData.data.find((obj) => obj.type === type);
          acc[key] = { content: found?.typeOptions };
          return acc;
        }, {});

        setData((prev) => ({ ...prev, ...updatedData }));
      } else {
        throw new Error(fetchedData.error);
      }
    } catch (err) {
      // Optional: You could log or toast the error here
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
    // fetchAmenities();
    // fetchProviders()
  }, []);

  return (
    <CommonContext.Provider
      value={{
        notificationCount,
        notifications,
        setNotifications,
        getAllNotifications,
        fetchData,
        fetchAmenities,
        fetchProviders,
        providerData,
        amenitiesData,
        data,
        loader,
      }}
    >
      {children}
    </CommonContext.Provider>
  );
};

export default NotificationContextProvider;
